// extracted by mini-css-extract-plugin
export default {"modalBody":"leaveJobModal_modalBody__yrrol","modalBodyText":"leaveJobModal_modalBodyText__jvYFC"};